import { render, staticRenderFns } from "./Currencybox.vue?vue&type=template&id=0e6ec0a3&"
import script from "./Currencybox.vue?vue&type=script&lang=ts&"
export * from "./Currencybox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports